import mappings from './mappings';
import { createSelector } from 'reselect';


export const getLastUpdatedUserProfile = state => state.settings.lastUpdatedUserProfile;
export const getRowsUserProfile = state => state.settings.rowsForUserProfile;
export const getUserProfileInitialised = state => state.settings.initialisedUserProfile;

export const getLastUpdatedStatus = state => state.settings.lastUpdatedStatusPage;
export const getRowsStatusPage = state => state.settings.rowsForStatusPage;
export const getStatusPageInitialised = state => state.settings.initialisedStatusPage;
export const getDefaultFilters = state => state.settings.defaultFilters;
export const getFilterDefinitions = state => state.settings.filterDefinitions;

export const combinedColumnsSelector = createSelector(
    state => state.settings.columnsForStatusPage,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);